import classes from "./ProductFilter.module.css";
import { Icon } from "@iconify/react";
import { useState } from "react";

const ProductFilter = ({ data, filterHandler }) => {
  const [filterVisible, setFilterVisible] = useState(false);

  const filter = () => {};

  const clearAllHandler = () => {
    const input = document.getElementsByTagName("input");
    for (let i of input) {
      i.checked = false;
    }
  };

  return (
    <div className={classes.filterContainer}>
      <div
        className={`${filterVisible ? classes.backdrop : ""}`}
        onClick={() => setFilterVisible(false)}
      ></div>
      <div className={classes.filterButtonWrapper}>
        {filterVisible && (
          <span className={classes.clearAll} onClick={clearAllHandler}>
            清除全部
          </span>
        )}
        <button
          className={classes.filter}
          onClick={() => setFilterVisible(!filterVisible)}
        >
          <span>篩選</span>
          <Icon icon="bi:filter" color="#363636" width="20" height="20" />
        </button>
      </div>
      <div
        className={`${classes.filterTypeContainer} ${
          filterVisible ? classes.visible : ""
        }`}
      >
        <div className={classes.filterTypeList}>
          <label>
            <input type="checkbox" value="bag" />
            <span>包袋類</span>
          </label>
          <label>
            <input type="checkbox" value="stationary" />
            <span>辦公文具</span>
          </label>
          <label>
            <input type="checkbox" value="cotton" />
            <span>功能性棉織品</span>
          </label>
          <label>
            <input type="checkbox" value="daily" />
            <span>居家日用品</span>
          </label>
          <label>
            <input type="checkbox" value="environmental" />
            <span>環保材質贈品</span>
          </label>
          <label>
            <input type="checkbox" value="toy" />
            <span>公仔造型</span>
          </label>
          <label>
            <input type="checkbox" value="company" />
            <span>企業贈金</span>
          </label>
          <label>
            <input type="checkbox" value="travel" />
            <span>旅遊商務</span>
          </label>
          <label>
            <input type="checkbox" value="luggage" />
            <span>登機箱</span>
          </label>
          <label>
            <input type="checkbox" value="umbrella" />
            <span>晴雨傘</span>
          </label>
          <label>
            <input type="checkbox" value="electronic" />
            <span>電子3C</span>
          </label>
          <label>
            <input type="checkbox" value="steel" />
            <span>馬口鐵盒</span>
          </label>
          <label>
            <input type="checkbox" value="kitchen" />
            <span>廚房鍋具</span>
          </label>
          <label>
            <input type="checkbox" value="ownbrand" />
            <span>自有品牌</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ProductFilter;
